
import React, { useEffect, useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import api from '../api';

export default function Layout() {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const [balance, setBalance] = useState(user.credits || 0);
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    const fetchBalance = () => {
      api.get('/credits/balance')
        .then((r) => {
          setBalance(r.data.credits);
        })
        .catch((err) => {
          console.error('Failed to fetch credit balance:', err);
        });
    };

    const fetchUnread = () => {
      api.get('/messages/inbox')
        .then((r) => {
          const messages = Array.isArray(r.data) ? r.data : [];
          setUnread(messages.filter((m) => !m.is_read).length);
        })
        .catch((err) => {
          console.error('Failed to fetch unread messages:', err);
        });
    };

    fetchBalance();
    fetchUnread();

    const i1 = setInterval(fetchBalance, 30000);
    const i2 = setInterval(fetchUnread, 10000);

    return () => {
      clearInterval(i1);
      clearInterval(i2);
    };
  }, []);

  const logout = () => {
    localStorage.clear();
    navigate('/login');
  };

  return (
    <div>
      <div className="sidebar">
        <div className="logo">📦 WA CRM</div>

        <nav>
          <NavLink to="/" end>
            🏠 Dashboard
          </NavLink>

          <NavLink to="/messages">
            💬 Messages
          </NavLink>

          <NavLink to="/reminder-logs">
            📋 Reminder Logs
          </NavLink>

          <NavLink to="/inbox">
            📥 Inbox
            {unread > 0 && (
              <span
                style={{
                  background: '#25d366',
                  color: '#fff',
                  borderRadius: '20px',
                  padding: '1px 6px',
                  fontSize: '10px',
                  marginLeft: '4px',
                }}
              >
                {unread}
              </span>
            )}
          </NavLink>

          <NavLink to="/credits">
            💳 Credits
          </NavLink>

          {user.role === 'admin' && (
            <NavLink to="/admin">
              ⚙️ Admin
            </NavLink>
          )}

          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              logout();
            }}
            style={{ color: '#e57373' }}
          >
            🚪 Logout
          </a>
        </nav>
      </div>

      <div className="main">
        <div className="topbar">
          <h2>WhatsApp CRM Panel</h2>

          <div className="user">
            👤 {user.name} &nbsp;|&nbsp; ₹
            {Number(balance || 0).toFixed(2)} credits
          </div>
        </div>

        <Outlet />
      </div>
    </div>
  );
}
